module.exports = __webpack_public_path__ + "img/arrow-up-red.633dab2e.svg";